var DATA_URI_PATTERN = /^data:(\S*?)?(;charset=[^;]+)?(;[^,]+?)?,(.+)/;

function matchDataUri(uri) {
  return DATA_URI_PATTERN.exec(uri);
}

module.exports = matchDataUri;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/reader/match-data-uri.js
// module id = 2449
// module chunks = 9